import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "@pentabd/ui";

import { SelectCommittee } from "@components";
import BasicInfo from "./BasicInfo";
import Documents from "./Documents";

import { getAccess } from "@helpers/permissionController";
import { useUser } from "@hooks/useUser";

import {
  createFinalReceive,
  updateFinalReceive,
} from "@api/procurements/procurementDetails/finalReceiving";
import {
  convertMultipleDocumentData,
  revertMultipleDocumentData,
} from "@utils/documentDataConvert";

import { FORM_FIELDS } from "@constants/form";

interface FinalReceivingFormProps {
  id: string | undefined;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setGetDataAfterUpdate: (arg: boolean) => void;
  finalReceiving: any;
}

const FINAL_RECEIVING = FORM_FIELDS.PROCUREMENT_DETAILS.FINAL_RECEIVING;

export function FinalReceivingForm({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  finalReceiving,
  setGetDataAfterUpdate,
}: FinalReceivingFormProps) {
  const { t } = useTranslation();

  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  const methods = useForm({
    values: revertMultipleDocumentData(finalReceiving, [
      FINAL_RECEIVING.UPLOAD,
    ]),
  });
  const { handleSubmit } = methods;
  const onSubmit = async (data: any) => {
    try {
      const convertedData = convertMultipleDocumentData(data, [
        FINAL_RECEIVING.UPLOAD,
      ]);
      let resData;

      if (finalReceiving?.id) {
        resData = await updateFinalReceive(
          convertedData,
          id as string,
          finalReceiving?.id,
        );
      } else {
        resData = await createFinalReceive(convertedData, id as string);
      }

      if (resData?.status === "SUCCESS") {
        setIsSuccessModalOpen(true);
        setGetDataAfterUpdate(true);
      }
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  return (
    <div>
      <FormProvider {...methods}>
        <form className="container d-flex flex-column gap-6" onSubmit={handleSubmit(onSubmit)}>
          <SelectCommittee name="finalReceivingCommitteeId" required />
          <BasicInfo />
          <Documents />

          <div className="text-end col-lg-10 py-10">
            {getAccess(roles, "PROCUREMENT_HR") && (
              <Button fill="outline" type="light" size="sm" htmlType="submit">
                {t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.BUTTONS.SAVE")}
              </Button>
            )}
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
